<template>
  <div class="notificationItem">
    <NavListItem :to="notification.route"
                 :selected="false"
                 :subtext="notification.subtext"
                 :date="notification.timestamp"
                 :user="notification.userIdent"
                 :name="notification.title"
                 @click="handleClick">
      <template #notification>
        <div class="indicators">
          <BrandIcon :name="notification.icon" :showFocus="false" />
          <button v-if="notification.canDelete"
                  id="delete"
                  class="delete"
                  title="Delete"
                  @click.stop.prevent="handleDelete"
                  @focusin.self="deleteButtonFocused = true"
                  @focusout.self="deleteButtonFocused = false">
            <BrandIcon class="icon deleteIcon"
                       name="light/delete-light"
                       title="Dismiss notification"
                       :showFocus="deleteButtonFocused">
            </BrandIcon>
          </button>
        </div>
      </template>
    </NavListItem>
  </div>
</template>

<script setup lang="ts">
import { Ref, ref } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { Notification } from '@/data/datatypes/Notification';
import NavListItem from '@/navigation/NavListItem.vue';

interface Props {
  notification: Notification;
}
defineProps<Props>();

interface Emits {
  (e: 'click', event: MouseEvent): void,
  (e: 'deleted'): void,
}
const emit = defineEmits<Emits>();

const deleteButtonFocused: Ref<boolean> = ref(false);

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  emit('deleted');
  return event;
}

function handleDelete(): void {
  //  Delete activity
  emit('deleted');
}
</script>

<style scoped lang="scss">
.indicators {
  color: $colour-icon-primary;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 3rem;
  margin-left: 0.75rem;

  button {
    &#delete {
      padding: 0;
      align-items: center;
      justify-content: center;

      &:focus-visible {
        outline: 0;
      }
    }
  }

  .deleteIcon {
    color: $colour-icon-primary;
  }
}
</style>
